<template>
  <el-dialog
    :title="'关联流程'"
    class="flow-dialog"
    :modal="false"
    :visible.sync="dialogFormVisible"
    width="80%"
    @close="close"
  >
    <div class="content-main-box content-main-box2">
      <div class="search-area">
        <el-row :gutter="24">
          <el-col :span="8">
            <div class="search-area-div w80">关键字搜索</div>
            <el-input
              v-model="page.searchKey"
              placeholder="请输入企业、组织、应付金额搜索"
              size="mini"
              class="ipt-sty"
            >
            </el-input>
          </el-col>
          <el-col :span="4">
            <el-button size="mini" type="info" @click="searchFlowList"
              >搜索</el-button
            >
            <el-button size="mini" type="danger" @click="empty">清空</el-button>
          </el-col>
        </el-row>
      </div>

      <el-table
        :header-cell-class-name="cellClass"
        stripe
        border
        ref="multipleTable1"
        highlight-current-row
        :height="tableHeight"
        :data="flowLists"
        :row-key="(row) => row.guid"
        :current-row-key="currentRowKey"
        @select="handleSelectFlow"
      >
        <el-table-column type="selection" :reserve-selection="true">
        </el-table-column>
        <!-- 流程名称 -->
        <el-table-column
          prop="flowName"
          label="流程名称"
          header-align="center"
          align="left"
          show-overflow-tooltip
        >
          <template slot-scope="scope">{{
            scope.row.approveVO && scope.row.approveVO.flowName
              ? scope.row.approveVO.flowName
              : "-"
          }}</template>
        </el-table-column>
        <!-- 发起人 -->
        <el-table-column
          prop="applyStaffName"
          width="96"
          label="发起人"
          header-align="center"
          align="left"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.applyStaffName || "-" }}
          </template>
        </el-table-column>
        <!-- 总服务商 -->
        <el-table-column
          prop="operationReportTenantName"
          label="总服务商"
          header-align="center"
          align="left"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.operationReportTenantName || "-" }}
          </template>
        </el-table-column>
        <!-- 接包服务商 -->
        <el-table-column
          prop="tenantName"
          label="接包服务商"
          header-align="center"
          align="left"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.tenantName || "-" }}
          </template>
        </el-table-column>
        <!-- 组织名称 -->
        <el-table-column
          prop="organisationName"
          label="组织名称"
          header-align="center"
          align="left"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.organisationName || "-" }}
          </template>
        </el-table-column>
        <!-- 核算月 -->
        <el-table-column
          prop="accountMonth"
          label="核算月"
          header-align="center"
          align="left"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.newAccountMonth || "-" }}
          </template>
        </el-table-column>
        <!-- 任务包名称 -->
        <el-table-column
          prop="taskTitleName"
          label="任务包名称"
          header-align="center"
          align="left"
          show-overflow-tooltip
        >
          <template slot-scope="scope">{{
            scope.row.operationReportTaskTitle
              ? JSON.parse(scope.row.operationReportTaskTitle).join("、")
              : "-"
          }}</template>
        </el-table-column>
        <!-- 应付金额 -->
        <el-table-column
          prop="payable"
          label="应付金额(元)"
          header-align="center"
          align="right"
          show-overflow-tooltip
        >
          <template slot-scope="scope">{{
            (scope.row.payable || "-") | numFmt | numDigit
          }}</template>
        </el-table-column>
        <el-table-column
          label="操作"
          header-align="center"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span class="txt-color" @click="seeDetail(scope.row)"
              >查看详情</span
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div slot="footer">
      <el-button plain size="mini" @click="close">取消</el-button>
      <el-button size="mini" type="info" @click="selectProcess()"
        >确定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    operationReportTenantGuid: {
      type: String,
      default: "",
    },
  },
  name: "RelatedStatementDialog",
  data() {
    return {
      dialogFormVisible: false,
      page: {
        searchKey: "",
      },
      flowLists: [],
      tableHeight: "60vh",
      currentRow: "",
      currentRowKey: "",
      selectSettDoc: [], // 勾选的结算单
    };
  },
  methods: {
    close() {
      this.dialogFormVisible = false;
      this.$emit("close");
    },
    open() {
      this.dialogFormVisible = true;
      this.searchFlowList();
    },
    cellClass(row) {
      if (row.columnIndex === 0) {
        return "disabledCheck";
      }
    },
    /**
     * 搜索关联流程
     */
    searchFlowList() {
      this.getFlowList(true);
    },
    /**
     * 清空搜索条件
     */
    empty() {
      this.page.searchKey = "";
      this.searchFlowList();
    },
    /**
     * 获取流程列表
     */
    async getFlowList() {
      const params = {
        operationReportTenantGuid: this.operationReportTenantGuid,
        serviceTenantGuid: localStorage.guid,
        searchKey: this.page.searchKey,
        billTypeList: [3], // [3]查对账单
        approveStateList: ["Y"],
      };
      const { data } = await this.api.postJson(
        `/${serverConfig.msSalesPerformService}/downstream/statement/list`,
        params
      );

      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return;
      }
      let list = data.data || [];
      this.flowLists = list.map((item) => {
        let newAccountMonth = JSON.parse(item.accountMonth) || [];
        newAccountMonth = newAccountMonth?.join(",") || "";
        return {
          ...item,
          newAccountMonth: newAccountMonth || "",
        };
      });
    },
    /**
     * 选择流程
     */
    handleSelectFlow(selection, row) {
      if (!selection.length) {
        this.currentRow = "";
        this.currentRowKey = "";
        this.selectSettDoc = [];
        return;
      }
      let firstServiceTenantGuid = selection[0]?.serviceTenantGuid || "";
      let firstApplyStaffGuid = selection[0]?.applyStaffGuid || "";
      let accountMonth = selection[0]?.accountMonth || "";

      const f = selection.every(
        (item) =>
          firstServiceTenantGuid === item.serviceTenantGuid &&
          firstApplyStaffGuid === item.applyStaffGuid &&
          accountMonth === item.accountMonth
      );
      if (!f) {
        this.$message.error(
          "请选择同一个核算月、同一个部门，同一个提交人员的对账单"
        );
        this.$refs.multipleTable1.toggleRowSelection(row, false);
        return;
      }
      this.currentRow = row;
      this.currentRowKey = row.guid;
      this.selectSettDoc = selection;
    },
    /**
     * 查看详情
     */
    seeDetail(row) {
      this.$router.push({
        path: `/settlementBillDetail`,
        query: {
          guid: row.guid,
          productGuid: this.$route.query.productGuid,
        },
      });
    },
    /**
     * 确定选择流程
     */
    selectProcess() {
      let { currentRow } = this;
      if (!currentRow["guid"]) return this.$message.error("请关联流程");

      // 计算应付总金额
      const totalPayable = this.getTotalPayable();

      // 构建关联流程显示文本
      const relevanceText = `${currentRow["applyStaffName"]} _ ${
        currentRow["operationReportTenantName"]
      } _ ${currentRow["newAccountMonth"]}${
        totalPayable ? " _ " + this.formatMoney(totalPayable) + "(元)" : ""
      }`;

      // 触发选择事件，将结果传递给父组件
      this.$emit("select", {
        currentRow,
        relevanceText,
        totalPayable: totalPayable.toFixed(2),
        selectSettDoc: this.selectSettDoc,
      });

      this.close();
    },
    /**
     * 获取付款总金额(展示用)
     */
    getTotalPayable() {
      let payable = this.selectSettDoc.map((item) =>
        item.payable ? item.payable : 0
      );
      return payable.reduce((prev, cur) => prev + cur, 0);
    },
    /**
     * 格式化金额
     */
    formatMoney(money) {
      if (!money && money !== 0) return "0.00";
      return parseFloat(money).toFixed(2);
    },
  },
};
</script>

<style scoped>
::v-deep .el-table .disabledCheck .cell .el-checkbox__inner {
  display: none;
}

::v-deep .el-table .disabledCheck .cell::before {
  content: "";
  text-align: center;
  line-height: 37px;
}
</style>
